import React from 'react';
import { Table } from "reactstrap";
import RedirectToLive from "../containers/RedirectToLive";

const ttStartList = (props) => {
  const {
    EventName,
    ttStartList,
    ExecuteUpdate,
  } = props;

  const content = ttStartList.map((item, i) =>
    <tr key={i}>
      <td>{item.Name} {item.HeatID}</td>
      <td>
        {item.HomeRank}
        <br></br>
        {item.BackRank}
      </td>
      <td>
        {item.HomeRiderBib}
        <br></br>
        {item.BackRiderBib}
      </td>
      <td>
        {item.HomeRiderName}
        <br></br>
        {item.BackRiderName}
      </td>
      <td>
        {item.HomeNat && <img
          src={process.env.PUBLIC_URL + '/Flags/' + (EventName.toLowerCase().includes('team') ? item.HomeRiderTeam : item.HomeNat) + '.bmp'}
          height="25"
          width="60"
          alt={item.HomeNat}
        />}
        <br></br>
        {item.BackNat && <img
          src={process.env.PUBLIC_URL + '/Flags/' + (EventName.toLowerCase().includes('team') ? item.BackRiderTeam : item.BackNat) + '.bmp'}
          height="25"
          width="60"
          alt={item.BackNat}
        />}
      </td>
      <td>
        {item.HomeTime}
        <br></br>
        {item.BackTime}
      </td>
    </tr>
  );

  const TTStartListTable = () => {
    return (
      <div className="container">
        <h2>{EventName} StartList</h2>
        <br />
        <br />
        <br />
        <Table>
          <thead>
            <tr>
              <th>Heat</th>
              <th>Rank</th>
              <th>Bib</th>
              <th>Name</th>
              <th>Team</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {content}
          </tbody>
        </Table>
      </div>
    );
  }

  return (
    <div>
      <RedirectToLive Update={ExecuteUpdate} />
      <TTStartListTable />
    </div>

  );
};

export default ttStartList;  